var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { classNames, titleCase } from '@shapeable/utils';
import { IconLabel } from '../elements/icon-label';
import { useEntityTypeIcon } from '@shapeable/icons';
var cls = classNames('entity-type-icon-label');
export var EntityTypeIconLabelDefaultProps = {
  size: 'small'
};
// -------- Styles -------->
// -------- Components -------->
var My = {
  Container: IconLabel
};
export var EntityTypeIconLabel = function (props) {
  var entityTypeName = props.entityTypeName,
    children = props.children,
    className = props.className,
    rest = __rest(props, ["entityTypeName", "children", "className"]);
  var Icon = useEntityTypeIcon(entityTypeName);
  return React.createElement(My.Container, __assign({}, rest, {
    icon: React.createElement(Icon, null),
    className: cls.name(className)
  }), children || titleCase(entityTypeName));
};
EntityTypeIconLabel.defaultProps = EntityTypeIconLabelDefaultProps;
EntityTypeIconLabel.cls = cls;